import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) => state.statusSlice.statusPlan;

export const selectOperationMode = (gridElementId: string) => {
  const selector = (state: RootState): string => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return "NA";
    return data?.operationType;
  };
  (selector as any)._fromSelector = "operationModeSelector";
  return selector;
};
